import { FormlyFieldConfig } from '@ngx-formly/core';
import { omit } from 'lodash';
import { forkJoin, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnCamera, SnContentType, SnSharePermissions } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';

import { SnShareFieldsGeneratorService } from '../../services';

@Component({
  selector: 'sn-bulk-share-dialog',
  templateUrl: './bulk-share-dialog.component.html',
  styleUrls: ['./bulk-share-dialog.component.scss'],
})
export class BulkShareDialogComponent implements OnInit, OnDestroy {
  public readonly form = new UntypedFormGroup({});
  public formFields: FormlyFieldConfig[];
  public formModel: any = {};
  public isLoading = false;

  private _destroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SnCamera[],
    private readonly _dialogRef: MatDialogRef<BulkShareDialogComponent>,
    private readonly _shareFieldsGenerator: SnShareFieldsGeneratorService,
    private readonly _camerasAPI: SnCamerasAPI,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._genFormFields();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public save(): void {
    this.isLoading = true;
    this._cd.detectChanges();
    const shares = this.formModel.shares;
    if (shares.length < 1) {
      this._dialogRef.close();
      return;
    }
    const params = omit(this.formModel, 'shares');
    const requests: any[] = [];
    this.data.forEach((cam) => {
      requests.push(
        this._camerasAPI.createShare(
          cam.id,
          shares.map((share: any) => {
            return {
              ...params,
              target_organization: share.id,
            };
          }),
        ),
      );
    });
    forkJoin(requests)
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this.isLoading = false;
        this._dialogRef.close();
        this._cd.detectChanges();
      });
  }

  private _genFormFields(): void {
    this.formFields = [
      {
        key: 'permissions',
        defaultValue: SnSharePermissions.View,
        hideExpression: true,
      },
      this._shareFieldsGenerator.getOrganizationAutocompleteField({}),
      ...this._shareFieldsGenerator.getAdditionalFields(SnContentType.Camera),
    ];
  }
}
